// Kullanıcı tipleri
export enum UserType {
  PASSENGER = 'PASSENGER',
  DRIVER = 'DRIVER'
}

export enum PassengerMembershipType {
  FREE = 'FREE',
  PREMIUM = 'PREMIUM'
}

export enum DriverContractType {
  COMMISSION = 'COMMISSION',
  FIXED = 'FIXED'
}

export interface PassengerMembership {
  type: PassengerMembershipType;
  amount: number;
  paid: boolean;
  paidAt?: Date;
  paymentMethod?: string;
  features: string[];
  validUntil?: Date | null;
}

export interface User {
  id: string;
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
  userType: UserType;
  isVerified: boolean;
  createdAt: Date;
  updatedAt: Date;
  city?: any;
}

export interface Passenger extends User {
  userType: UserType.PASSENGER;
  favoriteLocations: any[];
  rating: number;
  totalRides: number;
  balance: number;
  membership: PassengerMembership;
}

export interface Driver extends User {
  userType: UserType.DRIVER;
  licenseNumber: string;
  vehicleInfo: {
    brand: string;
    model: string;
    year: number;
    plate: string;
    color: string;
  };
  isOnline: boolean;
  rating: number;
  totalRides: number;
  balance: number;
  documents?: Array<{
    type: 'LICENSE' | 'VEHICLE_REGISTRATION' | 'INSURANCE';
    url: string;
    verified: boolean;
    uploadedAt: Date;
  }>;
  contractType?: DriverContractType;
  commissionRate?: number;
  city?: any;
}

export interface Ride {
  id: string;
  passengerId: string;
  driverId?: string;
  pickupLocation: {
    latitude: number;
    longitude: number;
    address: string;
  };
  dropoffLocation: {
    latitude: number;
    longitude: number;
    address: string;
  };
  status: 'REQUESTED' | 'ACCEPTED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED';
  fare: number;
  distance?: number;
  duration?: number;
  createdAt: Date;
  updatedAt: Date;
  completedAt?: Date;
} 